import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import DialogModal from '../../common/DialogModal';
import Typography from 'material-ui/Typography';
import Button from '../../Parts/Button';

const styles = () => ({
  contentContainer: {
    padding: '50px 40px',
    margin: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '450px',
    boxSizing: 'border-box',
    background: '#FFFFFF',
    textAlign: 'left',
  },

  buttonContainer: {
    display: 'inline-flex',
    width: '100%',
    justifyContent: 'space-evenly',
    marginTop: '40px',
  }
});

class ExeSearchNoMatchDialog extends React.Component {
  componentWillReceiveProps(nextProps) {
    if (this.props.isPostingFilter && !nextProps.isPostingFilter) {
      this.props.toggleDialog();
    }
  }

  render() {
    const { classes, toggleDialog, isOpen } = this.props;

    return (
      <DialogModal
        open={isOpen}
        onClose={toggleDialog}
        aria-labelledby="pop-up-window"
        maxWidth={false}
        classes={{
          contentContainer: classes.contentContainer
        }}
      >
        <Typography variant="subheading" className={classes.text}>
          会社名に該当する列が見つかりませんでした。「会社名」「Company」「企業名」「組織名」のいずれかの列が存在するかご確認ください。
        </Typography>
        <div className={classes.buttonContainer}>
          <Button
            handleClickButton={toggleDialog}
            text="OK">
          </Button>
        </div>
      </DialogModal>
    );
  }
}

ExeSearchNoMatchDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  isPostingFilter: PropTypes.bool,
};

export default withStyles(styles)(ExeSearchNoMatchDialog);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/dialogs/ExeSearchNoMatchDialog.jsx